module.exports = __webpack_public_path__ + "static/img/bbgj.781d1d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bbgj.png
// module id = edHg
// module chunks = 0